<style lang="scss"></style>

<!-- eslint-disable -->
<template>
  <div class="col-12 request-booking-slot">
    <section class="request-call-page__title mb-3">
      <h2 class="font-weight-bolder mb-2">Request Call - Booking Slot</h2>

      <h4>Please select the date and time for your request booking slot.</h4>
    </section>

    <section>
      <label>Date</label>

      <b-form-datepicker @input="setBookingDate($event)" :value="bookingDate" locale="en" class="mb-1"
                         dropright cy="booking-slot"
                         close-button
                         :min="minDate"
                         :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
      ></b-form-datepicker>
    </section>

    <section v-if="bookingDate">
      <section v-if="slotsAvailable.length > 0">
        <b-form-select @input="$store.commit('requestCall/SET_BOOKING_SLOT', $event)" :value="bookingSlot"
                       :options="slotsAvailable" cy="booking-select">
          <b-form-select-option :value="null">Select a Booking Slot</b-form-select-option>
        </b-form-select>

        <p class="mt-1">Please note that all times show are in {{prison.name}} timezone of {{prison.timezone}}</p>
      </section>
      <p v-else>There are no booking slots available for this date. Please select a different date</p>
    </section>

    <section class="d-flex full-width mt-1" v-if="showNextButtons">
      <b-btn @click="backStage" variant="outline-primary">Back</b-btn>
      <div class="ui-spacer"></div>
      <b-btn :class="{'disabled': !bookingSlot}"
        @click="$store.commit('requestCall/SET_STAGE', 4)" variant="primary">Next</b-btn>
    </section>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import PrisonService from '@/services/PrisonService';

export default {
  name: 'RequestCallBookingSlot',
  components: {},
  props: {
    showNextButtons: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      placeholder: require('../../../assets/images/id/placeholder.png'),
      loading: false,
      minDate: null,
      slotsAvailable: [],
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      slots: state => state.requestCall.slots,
      prison: state => state.auth.prison,
      bookingDate: state => state.requestCall.booking.date,
      bookingSlot: state => state.requestCall.booking.bookingSlot,
    }),
  },
  mounted() {
    this.minDate = moment().add(2, 'days').format('YYYY-MM-DD');
    this.getBookingSlots();
  },
  methods: {
    getBookingSlots() {
      this.loading = true;

      this.$store.dispatch('requestCall/getSlots').finally(() => {
        this.loading = false;
      })
    },
    setBookingDate(date) {
      this.$store.commit('requestCall/SET_BOOKING_DATE', date);
      this.$store.commit('requestCall/SET_BOOKING_SLOT', null); // reset slot
      this.getAvailableBookingSlots();
    },
    getAvailableBookingSlots() {
      const slots = PrisonService.getAvailableBookingSlots(this.slots, this.bookingDate);

      this.slotsAvailable = slots.map(slot => ({ ...slot, text: slot.name, value: slot }))
    },
    backStage() {
      this.$store.commit('requestCall/SET_STAGE', this.prison.enable_wings ? 2 : 1)
    },
  },
}
</script>
